export default __webpack_public_path__ + "static/assets/47a31ffe10589efbb521b87ed70b8b76.jpg";